import { useState } from "react";
import { useI18n } from "../context/I18nContext";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "./ui/dialog";
import { PenLine } from "lucide-react";

/** Asks the user for their personal signing token. onConfirm(token) — token may be "" (skip signature). */
export function SignTokenDialog({ open, onOpenChange, onConfirm, title, allowSkip = true, skipLabel, confirmLabel, testid = "sign" }) {
  const { t } = useI18n();
  const [token, setToken] = useState("");
  const close = () => { setToken(""); onOpenChange(false); };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) close(); }}>
      <DialogContent className="rounded-none sm:max-w-md" data-testid={`${testid}-token-dialog`}>
        <DialogHeader>
          <DialogTitle className="uppercase font-black flex items-center gap-2"><PenLine size={14} /> {title || t("rq.signWithToken")}</DialogTitle>
          <DialogDescription className="text-xs">{t("rq.signHint")}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1">
          <Label className="text-[10px] font-bold uppercase tracking-widest">{t("rq.signToken")}</Label>
          <Input value={token} onChange={(e) => setToken(e.target.value.toUpperCase())} placeholder="XXXX-XXXX-XXXX"
            className="rounded-none h-9 text-sm font-mono tracking-widest" autoFocus data-testid={`${testid}-token-input`} />
        </div>
        <DialogFooter className="gap-2">
          {allowSkip && (
            <Button variant="outline" className="rounded-none text-xs font-bold" data-testid={`${testid}-token-skip`}
              onClick={() => { onConfirm(""); close(); }}>{skipLabel || t("common.approve")}</Button>
          )}
          <Button className="rounded-none text-xs font-bold" disabled={!token.trim()} data-testid={`${testid}-token-confirm`}
            onClick={() => { onConfirm(token.trim()); close(); }}>{confirmLabel || t("rq.approveAndSign")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
